import React, { Fragment } from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { H6, NoTranslate, Form } from '@contently/toolkit';
import { classNamePrefix, componentStyles, theme, menuPlacement } from './styles';
import DropdownIndicator from './dropdown_indicator';

const EnhancedSelect = props => {
  const {
    id,
    label,
    options,
    selectedValue,
    multi,
    placeholder,
    errors,
    touched,
    required,
    setFieldValue,
    setFieldTouched,
    noTranslate,
    renderSubtext,
    isClearable
  } = props;

  const formatLabel = labelObject =>
    noTranslate ? <NoTranslate text={labelObject.label} /> : labelObject.label;

  const IndicatorSeparator = () => '';

  const getValueOption = valueHash => {
    const { value } = valueHash;

    const flattened = options.reduce((prev, curr) => {
      if (curr.options) return prev.concat(curr.options);
      return prev.concat(curr);
    }, []);
    return flattened.filter(f => {
      if (Array.isArray(selectedValue)) {
        return selectedValue.find(v => v.value === f.value) != null;
      }
      return f.value === (selectedValue || {}).value || f.value === value;
    });
  };

  const filterOption = (option, str) => {
    if (str.trim().length === 0) return true;
    return option.data.label.toLowerCase().includes(str.toLowerCase());
  };

  if (!options.length) return <span />;
  return (
    <Fragment>
      <H6 required={!!required} htmlFor={id}>
        {label}
      </H6>
      {renderSubtext && renderSubtext()}
      <Form.ErrorWrapper errors={errors} touched={touched}>
        <Select
          components={{ DropdownIndicator, IndicatorSeparator }}
          isClearable={isClearable}
          id={id}
          options={options}
          isMulti={multi}
          onChange={value => setFieldValue(id, value || { value: null })}
          onBlur={() => setFieldTouched(id, true)}
          value={getValueOption({ value: selectedValue })}
          placeholder={placeholder}
          className={errors ? 'invalid' : ''}
          classNamePrefix={classNamePrefix}
          getOptionLabel={formatLabel}
          getValueLabel={formatLabel}
          styles={componentStyles(errors, touched)}
          theme={theme}
          filterOption={filterOption}
          menuPlacement={menuPlacement}
        />
      </Form.ErrorWrapper>
    </Fragment>
  );
};

EnhancedSelect.defaultProps = {
  id: null,
  label: '',
  options: [],
  selectedValue: {},
  multi: false,
  placeholder: '',
  errors: '',
  touched: false,
  required: false,
  noTranslate: false,
  isClearable: false
};

EnhancedSelect.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.instanceOf(Object)),
  selectedValue: PropTypes.instanceOf(Object),
  multi: PropTypes.bool,
  placeholder: PropTypes.string,
  errors: PropTypes.string,
  touched: PropTypes.bool,
  required: PropTypes.bool,
  setFieldValue: PropTypes.func.isRequired,
  setFieldTouched: PropTypes.func.isRequired,
  noTranslate: PropTypes.bool,
  isClearable: PropTypes.bool
};

export default EnhancedSelect;



// WEBPACK FOOTER //
// ./app/javascript/app/components/forms/enhanced_select/enhanced_select.jsx